









import Vue from 'vue'
import Component from 'vue-class-component'
import { Action } from 'vuex-class'

import UserInterface2FolderDataTable from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-2-folder-data-table.vue'

import {
  DataTableFile,
  GraphViewDataTableItem,
  itemTypeFolder,
  itemTypeGraph,
  itemTypeDescriptionList,
  itemTypeAccount
} from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/service-for-data-structures/data-structures-1-file-system-data-structure'

import {
  NUMBER_OF_CREATED_ACCOUNTS_VALUE,
  NUMBER_OF_DELETED_ACCOUNTS_VALUE,
  NUMBER_OF_ACTIVE_ACCOUNTS_VALUE,
  NUMBER_OF_CREATED_ACCOUNTS_GRAPH,
  NUMBER_OF_DELETED_ACCOUNTS_GRAPH,
  RECENTLY_CREATED_ACCOUNTS_DATA_TABLE,
  RECENTLY_DELETED_ACCOUNTS_DATA_TABLE,
  NUMBER_OF_ACTIVE_ACCOUNTS_GRAPH
} from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-3-constants/constants-2-account-network-statistics'

import { DigitalCurrencyAccount } from '../../../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-2-data-structures/data-structures-type-1-service-data-structure/service-data-structure-1'

import { addDatedElementToList } from '../../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-algorithms/helper-algorithms-8-add-dated-element-to-list'

import moment from 'moment'

const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface2FolderDataTable
  }
})
class AccountResourceItem1Statistics extends Vue {

  @Action('getDigitalCurrencyAccountNetworkStatistics', { namespace }) getDigitalCurrencyAccountNetworkStatistics?: any
  @Action('addEventListenerToDigitalCurrencyAccountNetworkStatistics', { namespace }) addEventListenerToDigitalCurrencyAccountNetworkStatistics?: any
  @Action('removeEventListenerFromDigitalCurrencyAccountNetworkStatistics', { namespace }) removeEventListenerFromDigitalCurrencyAccountNetworkStatistics?: any

  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any

  numberOfCreatedAccountsValue: number = 0
  numberOfCreatedAccountsValueEventListenerId: string = ''

  numberOfDeletedAccountsValue: number = 0
  numberOfDeletedAccountsValueEventListenerId: string = ''

  numberOfActiveAccountsValue: number = 0
  numberOfActiveAccountsValueEventListenerId: string = ''

  numberOfCreatedAccountsGraphDateList: number[] = []
  numberOfCreatedAccountsGraphDataList: number[] = []
  numberOfCreatedAccountsGraphEventListenerId: string = ''

  numberOfDeletedAccountsGraphDateList: number[] = []
  numberOfDeletedAccountsGraphDataList: number[] = []
  numberOfDeletedAccountsGraphEventListenerId: string = ''

  numberOfActiveAccountsGraphDateList: number[] = []
  numberOfActiveAccountsGraphDataList: number[] = []
  numberOfActiveAccountsGraphEventListenerId: string = ''

  recentlyCreatedAccountDataList: Array<GraphViewDataTableItem> = []
  recentlyCreatedAccountEventListenerId: string = ''
  recentlyCreatedAccountIdDataQueue: string[] = []

  recentlyDeletedAccountDataList: Array<GraphViewDataTableItem> = []
  recentlyDeletedAccountEventListenerId: string = ''
  recentlyDeletedAccountIdDataQueue: string[] = []

  // Get the initial statistics
  async mounted () {
    await this.initializeNumberOfCreatedAccountsValue()
    await this.initializeNumberOfDeletedAccountsValue()
    await this.initializeNumberOfActiveAccountsValue()
    await this.initializeNumberOfCreatedAccountsGraph()
    await this.initializeNumberOfDeletedAccountsGraph()
    await this.initializeNumberOfActiveAccountsGraph()
    await this.initializeRecentlyCreatedAccountList()
    await this.initializeRecentlyDeletedAccountList()
  }

  // Remove event listeners from statistics
  destroyed () {
    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_CREATED_ACCOUNTS_VALUE,
      eventListenerId: this.numberOfCreatedAccountsValueEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_DELETED_ACCOUNTS_VALUE,
      eventListenerId: this.numberOfDeletedAccountsValueEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_ACTIVE_ACCOUNTS_VALUE,
      eventListenerId: this.numberOfActiveAccountsValueEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_CREATED_ACCOUNTS_GRAPH,
      eventListenerId: this.numberOfCreatedAccountsGraphEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_DELETED_ACCOUNTS_GRAPH,
      eventListenerId: this.numberOfDeletedAccountsGraphEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_ACTIVE_ACCOUNTS_GRAPH,
      eventListenerId: this.numberOfActiveAccountsGraphEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: RECENTLY_CREATED_ACCOUNTS_DATA_TABLE,
      eventListenerId: this.recentlyCreatedAccountEventListenerId
    })

    this.removeEventListenerFromDigitalCurrencyAccountNetworkStatistics({
      statisticsType: RECENTLY_DELETED_ACCOUNTS_DATA_TABLE,
      eventListenerId: this.recentlyDeletedAccountEventListenerId
    })
  }

  // Initialize Number of Created Accounts Value
  async initializeNumberOfCreatedAccountsValue () {
    const numberOfCreatedAccounts = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_CREATED_ACCOUNTS_VALUE,
      statisticsOptions: {}
    })
    this.numberOfCreatedAccountsValue = numberOfCreatedAccounts

    this.numberOfCreatedAccountsValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_CREATED_ACCOUNTS_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfCreatedAccountsValue = data
      }
    })
  }

  // Initialize Number of Deleted Accounts Value
  async initializeNumberOfDeletedAccountsValue () {
    const numberOfDeletedAccounts = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_DELETED_ACCOUNTS_VALUE,
      statisticsOptions: {}
    })
    this.numberOfDeletedAccountsValue = numberOfDeletedAccounts

    this.numberOfDeletedAccountsValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_DELETED_ACCOUNTS_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfDeletedAccountsValue = data
      }
    })
  }

  // Initialize Number of Active Accounts
  async initializeNumberOfActiveAccountsValue () {
    const numberOfActiveAccounts = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_ACTIVE_ACCOUNTS_VALUE,
      statisticsOptions: {}
    })
    this.numberOfActiveAccountsValue = numberOfActiveAccounts

    this.numberOfActiveAccountsValueEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_ACTIVE_ACCOUNTS_VALUE,
      eventListenerCallbackFunction: (data: any) => {
        this.numberOfActiveAccountsValue = data
      }
    })
  }

  // Initialize Number of Created Accounts
  async initializeNumberOfCreatedAccountsGraph () {
    const networkStatistics = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_CREATED_ACCOUNTS_GRAPH,
      statisticsOptions: {}
    })
    const numberOfCreatedAccountsGraphDateList = networkStatistics.dateList.reverse()
    const numberOfCreatedAccountsGraphDataList = networkStatistics.dataList.reverse()

    Vue.set(this, 'numberOfCreatedAccountsGraphDateList', numberOfCreatedAccountsGraphDateList)
    Vue.set(this, 'numberOfCreatedAccountsGraphDataList', numberOfCreatedAccountsGraphDataList)

    this.numberOfCreatedAccountsGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_CREATED_ACCOUNTS_GRAPH,
      eventListenerCallbackFunction: this.eventListenerForNumberOfCreatedAccountsGraph
    })
  }

  // Initialize Number of Deleted Accounts
  async initializeNumberOfDeletedAccountsGraph () {
    const networkStatistics = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_DELETED_ACCOUNTS_GRAPH,
      statisticsOptions: {}
    })
    const numberOfDeletedAccountsGraphDateList = networkStatistics.dateList.reverse()
    const numberOfDeletedAccountsGraphDataList = networkStatistics.dataList.reverse()

    Vue.set(this, 'numberOfDeletedAccountsGraphDateList', numberOfDeletedAccountsGraphDateList)
    Vue.set(this, 'numberOfDeletedAccountsGraphDataList', numberOfDeletedAccountsGraphDataList)

    this.numberOfDeletedAccountsGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_DELETED_ACCOUNTS_GRAPH,
      eventListenerCallbackFunction: this.eventListenerForNumberOfDeletedAccountsGraph
    })
  }

  // Initialize Number of Active Accounts
  async initializeNumberOfActiveAccountsGraph () {
    const networkStatistics = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_ACTIVE_ACCOUNTS_GRAPH,
      statisticsOptions: {}
    })
    const numberOfActiveAccountsGraphDateList = networkStatistics.dateList.reverse()
    const numberOfActiveAccountsGraphDataList = networkStatistics.dataList.reverse()

    Vue.set(this, 'numberOfActiveAccountsGraphDateList', numberOfActiveAccountsGraphDateList)
    Vue.set(this, 'numberOfActiveAccountsGraphDataList', numberOfActiveAccountsGraphDataList)

    this.numberOfActiveAccountsGraphEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: NUMBER_OF_ACTIVE_ACCOUNTS_GRAPH,
      eventListenerCallbackFunction: this.eventListenerForNumberOfActiveAccountsGraph
    })
  }

  // Initialize Recently Created Account List
  async initializeRecentlyCreatedAccountList () {
    const networkStatistics = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: RECENTLY_CREATED_ACCOUNTS_DATA_TABLE,
      statisticsOptions: {}
    })

    let recentlyCreatedAccountDataList: Array<GraphViewDataTableItem> = []

    for (let i = 0; i < networkStatistics.dataList.length; i++) {
      const digitalCurrencyAccountId = networkStatistics.dataList[i]
      const digitalCurrencyAccount: DigitalCurrencyAccount = await this.getDigitalCurrencyAccountById(digitalCurrencyAccountId)

      recentlyCreatedAccountDataList.push({
        itemType: itemTypeAccount,
        itemId: digitalCurrencyAccount ? digitalCurrencyAccount.accountId : digitalCurrencyAccountId,
        itemName: digitalCurrencyAccount ? digitalCurrencyAccount.accountName : '(Deleted)',
        dateCreated: digitalCurrencyAccount ? moment(digitalCurrencyAccount.dateAccountCreated).fromNow() : '',
        itemIconImageUrl: digitalCurrencyAccount ? digitalCurrencyAccount.accountProfilePictureUrl : 'person',
        openFolderOrFileItem: digitalCurrencyAccount ? true : false,
        closingActionButtonIconId: 'visibility',
        closingActionButtonText: digitalCurrencyAccount ? 'View Account' : ''
      })
    }

    this.recentlyCreatedAccountDataList = recentlyCreatedAccountDataList.reverse()

    this.recentlyCreatedAccountEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: RECENTLY_CREATED_ACCOUNTS_DATA_TABLE,
      eventListenerCallbackFunction: this.eventListenerForRecentlyCreatedAccountDataTable
    })
  }

  // Initialize Recently Deleted Account List
  async initializeRecentlyDeletedAccountList () {
    const networkStatistics = await this.getDigitalCurrencyAccountNetworkStatistics({
      statisticsType: RECENTLY_DELETED_ACCOUNTS_DATA_TABLE,
      statisticsOptions: {}
    })

    let recentlyDeletedAccountDataList: Array<GraphViewDataTableItem> = []

    for (let i = 0; i < networkStatistics.dataList.length; i++) {
      const digitalCurrencyAccountId = networkStatistics.dataList[i]

      recentlyDeletedAccountDataList.push({
        itemType: itemTypeAccount,
        itemId: digitalCurrencyAccountId,
        itemName: '(Deleted)',
        dateCreated: '',
        itemIconImageUrl: 'person'
      })
    }

    this.recentlyDeletedAccountDataList = recentlyDeletedAccountDataList.reverse()

    this.recentlyDeletedAccountEventListenerId = await this.addEventListenerToDigitalCurrencyAccountNetworkStatistics({
      statisticsType: RECENTLY_DELETED_ACCOUNTS_DATA_TABLE,
      eventListenerCallbackFunction: this.eventListenerForRecentlyDeletedAccountDataTable
    })
  }

  get getDataTableInitialFile () {

    const initialFile = new DataTableFile()

    const fileForValues: DataTableFile = {
      itemType: itemTypeDescriptionList,
      itemId: 'values',
      itemName: 'Values',
      itemIconImageUrl: 'plus_one',
      itemData: {
        descriptionListItemList: [{
          propertyName: 'Number of Created Accounts',
          propertyIconId: 'person',
          propertyValue: this.numberOfCreatedAccountsValue || 0,
          showAnimatedCurrencyLabel: true,
          animatedCurrencyLabelPropertyShowVerticalUpdateList: false
        }, {
          propertyName: 'Number of Deleted Accounts',
          propertyIconId: 'delete',
          propertyValue: this.numberOfDeletedAccountsValue || 0,
          showAnimatedCurrencyLabel: true,
          animatedCurrencyLabelPropertyShowVerticalUpdateList: false
        }, {
          propertyName: 'Total Active Accounts',
          propertyIconId: 'person',
          propertyValue: this.numberOfActiveAccountsValue || 0,
          showAnimatedCurrencyLabel: true,
          animatedCurrencyLabelPropertyShowVerticalUpdateList: false
        }]
      }
    }

    const recentlyCreatedAccountDataTable = this.recentlyCreatedAccountDataList.reduce((map: any, obj: any, index: number) => (map[obj.itemId] = this.recentlyCreatedAccountDataList[index], map), {})
    const recentlyDeletedAccountDataTable = this.recentlyDeletedAccountDataList.reduce((map: any, obj: any, index: number) => (map[obj.itemId] = this.recentlyDeletedAccountDataList[index], map), {})

    const fileForDataTables: DataTableFile = {
      itemType: itemTypeFolder,
      itemId: 'data-tables',
      itemName: 'Data Tables',
      itemIconImageUrl: 'list',
      fileVariableTable: {
        'recently-created-accounts': {
          itemType: itemTypeGraph,
          itemId: 'recently-created-accounts',
          itemName: 'Recently Created Accounts',
          itemIconImageUrl: 'list',
          fileVariableTable: recentlyCreatedAccountDataTable,
          itemData: {
            graphType: 'data-table',
            graphData: {
              hasOpeningIcon: true,
              hasClosingActionButton: true,
              dataTableSearchTextFieldLabel: 'Search Accounts',
              dataTableHeaderList: [{
                text: 'Account Id',
                value: 'itemId'
              }, {
                text: 'Account Name',
                value: 'itemName'
              }, {
                text: 'Time Created',
                value: 'dateCreated'
              }],
              dataTableDataList: this.recentlyCreatedAccountDataList
            }
          }
        },
        'recently-deleted-accounts': {
          itemType: itemTypeGraph,
          itemId: 'recently-deleted-accounts',
          itemName: 'Recently Deleted Accounts',
          itemIconImageUrl: 'list',
          fileVariableTable: recentlyDeletedAccountDataTable,
          itemData: {
            graphType: 'data-table',
            graphData: {
              hasOpeningIcon: true,
              hasClosingActionButton: true,
              dataTableSearchTextFieldLabel: 'Search Accounts',
              dataTableHeaderList: [{
                text: 'Account Id',
                value: 'itemId'
              }, {
                text: 'Account Name',
                value: 'itemName'
              }, {
                text: 'Time Created',
                value: 'dateCreated'
              }],
              dataTableDataList: this.recentlyDeletedAccountDataList
            }
          }
        }
      }
    }

    const fileForBarGraphs: DataTableFile = {
      itemType: itemTypeFolder,
      itemId: 'bar-graphs',
      itemName: 'Bar Graphs',
      itemIconImageUrl: 'bar_chart',
      fileVariableTable: {
        'number-of-accounts-created': {
          itemType: itemTypeGraph,
          itemId: 'number-of-accounts-created',
          itemName: 'Number of Accounts Created',
          itemIconImageUrl: 'bar_chart',
          itemData: {
            graphType: 'bar-graph',
            graphData: {
              xAxisLabel: 'Date',
              yAxisLabel: 'Number of Created Accounts',
              dateList: this.numberOfCreatedAccountsGraphDateList,
              dataList: this.numberOfCreatedAccountsGraphDataList
            }
          }
        },
        'number-of-accounts-deleted': {
          itemType: itemTypeGraph,
          itemId: 'number-of-accounts-deleted',
          itemName: 'Number of Accounts Deleted',
          itemIconImageUrl: 'bar_chart',
          itemData: {
            graphType: 'bar-graph',
            graphData: {
              xAxisLabel: 'Date',
              yAxisLabel: 'Number of Deleted Accounts',
              dateList: this.numberOfDeletedAccountsGraphDateList,
              dataList: this.numberOfDeletedAccountsGraphDataList
            }
          }
        },
        'total-active-accounts': {
          itemType: itemTypeGraph,
          itemId: 'total-active-accounts',
          itemName: 'Total Active Accounts',
          itemIconImageUrl: 'bar_chart',
          itemData: {
            graphType: 'bar-graph',
            graphData: {
              xAxisLabel: 'Date',
              yAxisLabel: 'Total Active Accounts',
              dateList: this.numberOfActiveAccountsGraphDateList,
              dataList: this.numberOfActiveAccountsGraphDataList
            }
          }
        }
      }
    }

    initialFile.fileVariableTable![fileForValues.itemId] = fileForValues
    initialFile.fileVariableTable![fileForDataTables.itemId] = fileForDataTables
    initialFile.fileVariableTable![fileForBarGraphs.itemId] = fileForBarGraphs

    return initialFile
  }

  eventListenerForNumberOfCreatedAccountsGraph (data: any) {
    const { dateList, dataList } = data

    if (!dateList || !dataList) {
      return
    }

    const mergedData = addDatedElementToList(this.numberOfCreatedAccountsGraphDateList, this.numberOfCreatedAccountsGraphDataList, dateList, dataList)
    Vue.set(this, 'numberOfCreatedAccountsGraphDateList', mergedData.dateList)
    Vue.set(this, 'numberOfCreatedAccountsGraphDataList', mergedData.dataList)

  }

  eventListenerForNumberOfDeletedAccountsGraph (data: any) {
    const { dateList, dataList } = data

    if (!dateList || !dataList) {
      return
    }

    const mergedData = addDatedElementToList(this.numberOfDeletedAccountsGraphDateList, this.numberOfDeletedAccountsGraphDataList, dateList, dataList)
    Vue.set(this, 'numberOfDeletedAccountsGraphDateList', mergedData.dateList)
    Vue.set(this, 'numberOfDeletedAccountsGraphDataList', mergedData.dataList)
  }

  eventListenerForNumberOfActiveAccountsGraph (data: any) {
    const { dateList, dataList } = data

    if (!dateList || !dataList) {
      return
    }

    const mergedData = addDatedElementToList(this.numberOfActiveAccountsGraphDateList, this.numberOfActiveAccountsGraphDataList, dateList, dataList)
    Vue.set(this, 'numberOfActiveAccountsGraphDateList', mergedData.dateList)
    Vue.set(this, 'numberOfActiveAccountsGraphDataList', mergedData.dataList)
  }

  async eventListenerForRecentlyCreatedAccountDataTable (data: any) {
    let { dataList } = data

    if (!dataList) {
      return
    }

    let digitalCurrencyAccountIdList = []

    // Check if it's already in the queue
    // or already in the data list
    for (let i = 0; i < dataList.length; i++) {
      const digitalCurrencyAccountId = dataList[i]
      const isAlreadyInQueue = this.recentlyCreatedAccountIdDataQueue.indexOf(digitalCurrencyAccountId) >= 0
      const isAlreadyInList = this.recentlyCreatedAccountDataList.filter(item => {
        return item.itemId === digitalCurrencyAccountId
      })[0] ? true : false

      if (isAlreadyInQueue || isAlreadyInList) {
        continue
      }
      digitalCurrencyAccountIdList.push(digitalCurrencyAccountId)
    }

    // Add data item to the queue
    this.recentlyCreatedAccountIdDataQueue = [...digitalCurrencyAccountIdList, ...this.recentlyCreatedAccountIdDataQueue]

    if (digitalCurrencyAccountIdList.length === 0) {
      return
    }

    let newDataList = []
    dataList = [...this.recentlyCreatedAccountIdDataQueue]

    for (let i = 0; i < dataList.length; i++) {
      const digitalCurrencyAccountId = dataList[i]

      const digitalCurrencyAccount: DigitalCurrencyAccount = await this.getDigitalCurrencyAccountById(digitalCurrencyAccountId)

      newDataList.push({
        itemType: itemTypeAccount,
        itemId: digitalCurrencyAccount ? digitalCurrencyAccount.accountId : digitalCurrencyAccountId,
        itemName: digitalCurrencyAccount ? digitalCurrencyAccount.accountName : '(Deleted)',
        dateCreated: digitalCurrencyAccount ? moment(digitalCurrencyAccount.dateAccountCreated).fromNow() : '',
        itemIconImageUrl: digitalCurrencyAccount ? digitalCurrencyAccount.accountProfilePictureUrl : 'person',
        openFolderOrFileItem: digitalCurrencyAccount ? true : false,
        closingActionButtonIconId: 'visibility',
        closingActionButtonText: digitalCurrencyAccount ? 'View Account' : ''
      })
    }

    newDataList = [...newDataList, ...this.recentlyCreatedAccountDataList]

    Vue.set(this, 'recentlyCreatedAccountDataList', newDataList)

    // Remove items from the queue
    for (let i = 0; i < digitalCurrencyAccountIdList.length; i++) {
      const dataItemIndex = this.recentlyCreatedAccountIdDataQueue.indexOf(digitalCurrencyAccountIdList[i])
      this.recentlyCreatedAccountIdDataQueue.splice(dataItemIndex, 1)
    }
  }

  eventListenerForRecentlyDeletedAccountDataTable (data: any) {
    let { dataList } = data

    if (!dataList) {
      return
    }

    let digitalCurrencyAccountIdList = []

    // Check if it's already in the queue
    // or already in the data list
    for (let i = 0; i < dataList.length; i++) {
      const digitalCurrencyAccountId = dataList[i]
      const isAlreadyInQueue = this.recentlyDeletedAccountIdDataQueue.indexOf(digitalCurrencyAccountId) >= 0
      const isAlreadyInList = this.recentlyDeletedAccountDataList.filter(item => {
        return item.itemId === digitalCurrencyAccountId
      })[0] ? true : false

      if (isAlreadyInQueue || isAlreadyInList) {
        continue
      }
      digitalCurrencyAccountIdList.push(digitalCurrencyAccountId)
    }

    // Add data item to the queue
    this.recentlyDeletedAccountIdDataQueue = [...digitalCurrencyAccountIdList, ...this.recentlyDeletedAccountIdDataQueue]

    if (digitalCurrencyAccountIdList.length === 0) {
      return
    }

    let newDataList = []
    dataList = [...this.recentlyDeletedAccountIdDataQueue]

    for (let i = 0; i < dataList.length; i++) {
      const digitalCurrencyAccountId = dataList[i]

      newDataList.push({
        itemType: itemTypeAccount,
        itemId: digitalCurrencyAccountId,
        itemName: '(Deleted)',
        dateCreated: '',
        itemIconImageUrl: 'person',
        openFolderOrFileItem: false
      })
    }

    newDataList = [...newDataList, ...this.recentlyDeletedAccountDataList]

    Vue.set(this, 'recentlyDeletedAccountDataList', newDataList)

    // Remove items from the queue
    for (let i = 0; i < digitalCurrencyAccountIdList.length; i++) {
      const dataItemIndex = this.recentlyDeletedAccountIdDataQueue.indexOf(digitalCurrencyAccountIdList[i])
      this.recentlyDeletedAccountIdDataQueue.splice(dataItemIndex, 1)
    }
  }
}

export default AccountResourceItem1Statistics


